import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Maps old Wix product-page URLs to the matching new product pages.
// Preserves SEO value from links Google indexed on the old site.
const OLD_URL_MAP = {
  "ceramic-flower-vase": "/product/chebe-powder",
  "minimalist-tote-bag": "/product/raw-shea-butter",
  "hydrating-eye-serum": "/product/chebe-hair-beard-oil",
  "knitted-golf-sweater": "/product/organic-chebe-butter",
  "round-eyeglasses": "/product/coconut-shampoo",
  "solid-wood-chair": "/product/coconut-conditioner",
  "foaming-facial-cleanser": "/product/braiding-gel",
};

const LegacyRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    // Old Wix product pages look like /product-page/<slug>
    const match = path.match(/^\/product-page\/([^/]+)/);
    if (match) {
      const slug = match[1];
      const dest = OLD_URL_MAP[slug] || "/shop";
      navigate(dest, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default LegacyRedirect;
